import { IonBackButton, IonButtons, IonContent, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import React, {useState, useEffect} from 'react'
import Api from "../../services/Api";
import { arrowForward } from 'ionicons/icons';



const ExploreNetworks = () => {
  const api = Api.getInstance()

  const [data, setData] = useState<Array<any>>([]);
  const [isInfiniteDisabled, setInfiniteDisabled] = useState(false);
  const [team, setTeam] = useState<Array<any>>([])

  useEffect(() => {
    getTeam()
    setInfiniteDisabled(false);
    setData([])
    // console.log('filter', myWalks, data)

  }, [])

  useEffect(() => {
    // console.log('disable', myWalks, data)
    if(team.length < 20) {
      setInfiniteDisabled(true);
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // console.log('push', myWalks, data)
    pushData()

  }, [team]) // eslint-disable-line react-hooks/exhaustive-deps


  const getTeam = () => {
    api.get('teams/public').then(res => res.json()).then(data => {
      if(data.status === 'ok'){
        console.log(data)
        setTeam(data.teams) 
      }
    })
}

  useEffect(() => {
    // console.log('push', myWalks, data)
    pushData()

  }, [team.length !== 0]) // eslint-disable-line react-hooks/exhaustive-deps

  const pushData = () => {
    const max = data.length + 20;
    const min = max - 20;
    const newData = [];
    for (let i = min; i < max; i++) {
      if(team[i]) {
        newData.push(team[i]);
      }
    }

    setData([
      ...data,
      ...newData
    ]);
  }

  const loadData = (ev: any) => {
    setTimeout(() => {
      pushData();

      ev.target.complete();

      if (data.length === team.length) {
        setInfiniteDisabled(true);
      }
    }, 500);
  }  
  
  return (
    <IonPage className="cheap_desktop">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton />
          </IonButtons>
          <IonTitle>Explore available networks</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          { data.map((obj, index) => (
            <IonItem key={index} routerLink={'/walk/team/' + obj.key}>
              <IonLabel className="ml-2">{obj.name}</IonLabel>
              <IonIcon icon={arrowForward} slot="end"/>
            </IonItem>
          ))}
        </IonList>
        <IonInfiniteScroll
        onIonInfinite={loadData}
        threshold="100px"
        disabled={isInfiniteDisabled}>
        <IonInfiniteScrollContent
          loadingSpinner="bubbles"
          loadingText="Loading more walks..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>
      </IonContent>
    </IonPage>
  )
}

export default ExploreNetworks;